import * as React from 'react';
import BreadcrumbsPrototype from '/react4xp/components/prototype/Breadcrumbs';
import type {BreadcrumbData} from '/types/CommonData';

export function Breadcrumb({data}: {data?: BreadcrumbData}) {
    if (!data?.hasBreadcrumbs) {
        return null;
    }

    return <BreadcrumbsPrototype items={data.items}/>;
}
